import React from "react";
import type { IRpgStat } from "../../../models/IRpgStat";
import { getAbilityTotal, formatMod } from "../../../pages/Characters/characterHelpers";
import { StatTile, type StatTileSize, type StatTileVariant } from "./StatTile";

export interface IAbilityScoreProps {
    stat: IRpgStat;
    size?: StatTileSize;
    variant?: StatTileVariant;
    showBonusBadge?: boolean;
    className?: string;
}

export function AbilityScore(props: IAbilityScoreProps): JSX.Element {
    const total = getAbilityTotal(props.stat);
    const bonusText = formatMod(props.stat.Modifier);
    const showBonusBadge = (props.showBonusBadge ? props.showBonusBadge : true);

    return (
        <StatTile
            label={props.stat.Name}
            value={total}
            bonus={bonusText}
            size={props.size}
            variant={props.variant}
            showValueRing={true}
            showBonusBadge={showBonusBadge}
            className={props.className}
        />
    );
}
